const EVENT_TYPE = "dashboard.component.hide";
export default {
  type: EVENT_TYPE,
  getJs: () => `
    case '${EVENT_TYPE}':
      var $comp = $('#' + data.componentId);
      if ($comp) {
          $comp.hide();
      }
      break;\n
  `,
};
